import React from 'react';

const Envelope = () => {
    return (
        <svg width={14} height={11.2} viewBox="0 0 14 11.2">
            <path
                d="M11.9 0H2.1A2.1 2.1 0 000 2.1v7a2.1 2.1 0 002.1 2.1h9.8A2.1 2.1 0 0014 9.1v-7A2.1 2.1 0 0011.9 0zM2.1 1.4h9.8a.7.7 0 01.7.7L7 5.516 1.4 2.1a.7.7 0 01.7-.7zm10.5 7.7a.7.7 0 01-.7.7H2.1a.7.7 0 01-.7-.7V3.7l5.236 3.2a.7.7 0 00.7 0L12.6 3.7z"
                fill="#8f99dc"
            />
        </svg>
    );
};

export default Envelope;
